import { styled } from 'styled-components';

export const VoucherBannerWrapper = styled.div`
  position: relative;
  display: flex;
  width: 334px;
  height: 162px;
  border-radius: 0 20px 20px 0;
  overflow: hidden;

  .line {
    position: absolute;
    top: 0;
    left: 70px;
  }
`;

export const Icon = styled.img`
  width: 67px;
  height: 67px;
  min-width: 67px;
`;
